var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPauseOwnerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26 13C26 20.1797 20.1797 26 13 26C5.8203 26 0 20.1797 0 13C0 5.8203 5.8203 0 13 0C20.1797 0 26 5.8203 26 13ZM7.91304 9.04348C7.91304 8.41916 8.41916 7.91304 9.04348 7.91304H10.5978C11.2221 7.91304 11.7283 8.41916 11.7283 9.04348V18.087C11.7283 18.7113 11.2221 19.2174 10.5978 19.2174H9.04348C8.41916 19.2174 7.91304 18.7113 7.91304 18.087V9.04348ZM15.4022 7.91304C14.7779 7.91304 14.2717 8.41916 14.2717 9.04348V18.087C14.2717 18.7113 14.7779 19.2174 15.4022 19.2174H16.9565C17.5808 19.2174 18.087 18.7113 18.087 18.087V9.04348C18.087 8.41916 17.5808 7.91304 16.9565 7.91304H15.4022Z",
    fill: "#ffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPauseOwnerIcon);
export default __webpack_public_path__ + "static/media/pause_owner_icon.9be41682404ac2c688cc6452187029d9.svg";
export { ForwardRef as ReactComponent };